<template>
  <div>
    <h2>{{$t('TEXT_SWAP')}} {{ wallet.name }} ({{ wallet.displaySymbol }})</h2>
    <form class="popup-inner" @submit.prevent="doSwap" :class="{ 'loading': isProcessing }">
      <div class="item">
        <label>{{$t('TEXT_CURRENCY')}}</label>
        <el-select v-model="swapForm.toSymbol" placeholder="Please choose currency">
          <el-option
            v-for="item in wallet.swapTo"
            :key="item.toSymbol"
            :label="item.toSymbol"
            :value="item.toSymbol">
            <img class="select-img" :src="item.imageUrl">
            <span>{{ item.toName }} - {{ item.toSymbol }}</span>
          </el-option>
        </el-select>
      </div>
      <div class="item">
        <label>{{$t('TEXT_AMOUNT')}}</label>
        <input
          type="text"
          autocomplete="off"
          required
          v-model="swapForm.amount"
          placeholder="0.000000"
        >
        <span class="field-description error-text" v-if="swapForm.amount && !isValidAmount">
          {{ $t('TEXT_MIN_SWAP_AMOUNT') }} {{minCurrencySwap}}&nbsp;{{wallet.currencyCode}}, {{ $t('TEXT_MAX_SWAP_AMOUNT') }} {{maxCurrencySwap}}&nbsp;{{wallet.currencyCode}}
        </span>
        <span class="field-description error-text" v-if="swapForm.amount && isValidAmount && isInValidAmountPrecision">
          {{ $t('MSG_MAXIMUM_AMOUNT_PRECISION_IS', { amountPrecision: this.wallet.numberDecimal}) }}
        </span>
        <span class="field-description error-text" v-else-if="isNaNAmount">
          {{ $t('MSG_AMOUNT_MUST_BE_A_NUMBER') }}
        </span>
        <p class="item-description mt-10">
          (
          <a @click="swapMax">
            <span class="label-pointer">{{ $t('BTN_MAX') }}</span>
          </a>
          -
          <a @click="swapMin">
            <span class="label-pointer">{{ $t('BTN_MIN') }}</span>
          </a>
          )
        </p>
      </div>
      <p class="item item-balance">{{ $t('TEXT_BALANCE') }}: <span class="dark-color font-medium">{{wallet.beautyBalance}}</span></p>
      <div class="item item-fee">
        <div class="flex-box">
          <div style="flex-basis: 140px">{{ $t('TEXT_SWAP_FEE') }}:</div>
          <div class="flex-grow dark-color">
            <span>{{feeSwap}}&nbsp;</span>
            <span>{{swapForm.toCurrency.feeSymbol}}</span>
          </div>
        </div>
        <div class="flex-box">
          <div style="flex-basis: 140px">{{$t('TEXT_YOU_WILL_GET')}}: </div>
          <div class="flex-grow buy-color">
            <span>{{estimateReceiveAmount}}&nbsp;</span>
            <span>{{swapForm.toSymbol}}</span>
          </div>
        </div>
        <div class="flex-box">
          <div style="flex-basis: 140px">&nbsp;</div>
          <div class="flex-grow buy-color">
            <span class="field-description error-text" v-if="!isValidFeeAmount">
              {{ $t('MSG_FEE_IS_NOT_ENOUGH') }}
            </span>
          </div>
        </div>
      </div>
      <div class="item item-submit">
        <a class="btn btn-submit" :class="{ 'disabled': !isValidated || isProcessing }" @click="doSwap">{{ $t('BTN_SWAP') }}</a>
      </div>
    </form>
  </div>
</template>

<script>
import UtilService from '@/utils/UtilService'
export default {
  props: {
    wallet: {}
  },
  data () {
    return {
      swapForm: {
        fromWallet: this.wallet,
        amount: null,
        toCurrency: {}
      },
      isProcessing: false,
      feeWallet: {}
    }
  },
  watch: {
    'swapForm.toSymbol' (n, o) {
      this.swapForm.toCurrency = this.swapWallets.find(temp => {
        return temp.toSymbol === n
      })
      if (this.swapForm.toCurrency.feeSymbol && this.swapForm.toCurrency.feeSymbol !== this.swapForm.toCurrency.fromSymbol) {
        this.feeWallet = this.ieoBalances.filter((temp) => temp.symbol === this.swapForm.toCurrency.feeSymbol)[0]
      }
    }
  },
  computed: {
    pagination () {
      return this.$store.getters.pagination
    },
    ieoBalances () {
      return this.$store.getters.ieoBalances
    },
    ieoBalancesActive () {
      return this.ieoBalances.filter(balance => {
        return balance.allowIeo
      })
    },
    swapWallets () {
      return this.wallet.swapTo
    },
    rate () {
      return this.swapForm.toCurrency.fromRate / this.swapForm.toCurrency.toRate
    },
    user () {
      return this.$store.getters.user
    },
    isExternalFee () {
      return this.swapForm.toCurrency.feeSymbol && this.swapForm.toCurrency.feeSymbol !== this.swapForm.toCurrency.fromSymbol
    },
    isValidFeeAmount () {
      if (this.isExternalFee) {
        const result = UtilService.isLessOrEqual(this.feeSwap, this.feeWallet.balanceIeo)
        return result
      }
      return true
    },
    isValidAmount () {
      let result = null
      if (this.swapForm.amount && UtilService.isLargerOrEqual(this.swapForm.amount, this.minCurrencySwap) &&
        UtilService.isLessOrEqual(this.swapForm.amount, this.maxCurrencySwap)) {
        result = true
      } else result = false
      return result
    },
    feeSwap () {
      return UtilService.calculateFeeSwap(this.wallet, this.swapForm.toCurrency, this.swapForm.amount)
    },
    maxCurrencySwap () {
      let result = 0
      if (!this.swapForm.toSymbol) return
      result = UtilService.calculateMaxSwap(this.wallet, this.swapForm.toCurrency)
      return result
    },
    estimateReceiveAmount () {
      if (!this.swapForm.amount) return 0
      return UtilService.calculateEstimateReceiveAmount(this.swapForm.amount, this.rate, this.swapForm.toCurrency.toNumberDecimal)
    },
    configs () {
      return this.$store.getters.configs
    },
    minSwap () {
      return this.wallet.minSwap
    },
    minCurrencySwap () {
      if (!this.swapForm.toCurrency.swapMinAmount) return
      return this.swapForm.toCurrency.swapMinAmount
    },
    isValidated () {
      return this.swapForm.amount && this.isValidAmount && !this.isInValidAmountPrecision && !this.isNaNAmount && this.isValidFeeAmount
    },
    isInValidAmountPrecision () {
      return this.swapForm.amount && !UtilService.checkValidAmountDecimals(this.swapForm.amount, this.wallet.numberDecimal)
    },
    isNaNAmount () {
      return !this.isInValidAmount && this.swapForm.amount && isNaN(this.swapForm.amount)
    }
  },
  methods: {
    swapMax () {
      this.swapForm.amount = this.maxCurrencySwap
    },
    swapMin () {
      this.swapForm.amount = this.minCurrencySwap
    },
    doSwap () {
      if (this.isProcessing || !this.isValidated) return
      const data = {}
      data.fromCurrency = this.wallet.symbol
      data.toCurrency = this.swapForm.toSymbol
      data.amount = this.swapForm.amount
      this.isProcessing = true
      this.$store.dispatch('swap', data).then(rs => {
        setTimeout(() => {
          this.isProcessing = false
          if (rs) {
            this.$store.dispatch('toggleAmountForm')
            this.$store.dispatch('getTransHistory', this.pagination.currentPage || 1)
          }
        }, 500)
      })
    }
  }
}
</script>
